import React from 'react';
import styled from 'styled-components';

import { SliderComponent, SliderHandle } from 'components/Shared/Forms/Slider';

const StyledSlider = styled(SliderComponent)`
    display: inline-block;
    vertical-align: middle;
    width: 10em;

    .rc-slider-track,
    .rc-slider-handle {
        background-color: #888;
    }
`;

const MapToolbarSlider = ({ previewZoom, onChange, ...props }) => {
    return (
        <StyledSlider
            step={0.01}
            min={0.1}
            max={1.0}
            value={previewZoom}
            onChange={(value) => {
                onChange(value);
            }}
            handle={SliderHandle}
            {...props}
        />
    );
};

export default MapToolbarSlider;
